// Home page 2026 redesign scripts.
// Enqueued alongside home.js on the front page only (see functions.php).

// customers slider
jQuery(function($) {
	$('.customers-slider').not('.slick-initialized').slick({
		infinite: true,
		slidesToShow: 4,
		centerMode: true,
		centerPadding: '5%',
		arrows: false,
		speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		rtl: $('html').attr('dir') === 'rtl',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
		]
	});
});


// new blog slider design
jQuery(function($) {
	$('.blog-slider, .resources-slider').not('.slick-initialized').not('.multiple-items .blog-slider').slick({
		infinite: true,
		slidesToShow: 3,
		arrows: false,
		responsive: [
			{ breakpoint: 1024, settings: { slidesToShow: 2 } },
			{ breakpoint: 767,  settings: { slidesToShow: 1 } },
		]
	});
});


// blog slider new design prev/next buttons
jQuery(function($) {
	$('.blog-slider-prev').on('click', function () {
		$('.blog-slider').slick('slickPrev');
	});
	$('.blog-slider-next').on('click', function () {
		$('.blog-slider').slick('slickNext');
	});
});


// case studies slider, 1 slide on every device, controlled by the gutenberg testimonial-nav-btns buttons
jQuery(function($) {
	$('.case-studies-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		rtl: $('html').attr('dir') === 'rtl'
	});

	$('.testimonial-prev').on('click', function () {
		$('.case-studies-slider').slick('slickPrev');
	});
	$('.testimonial-next').on('click', function () {
		$('.case-studies-slider').slick('slickNext');
	});
});


// Accordion scroll up
jQuery(function($) {
	if ($(window).width() <= 1200) {
		$('#accordionSwift .collapse, .card-accordion-1 .collapse, .card-accordion-2 .collapse, .new-design .accordion-faq .collapse').on('shown.bs.collapse', function(e) {
			e.preventDefault();
			const card = $(this).closest('.accordion-item, .col');
			const open = $($(this).data('parent')).find('.collapse.show');
			let additionalOffset = 0;
			if(card.prevAll().filter(open.closest('.accordion-item, .col')).length !== 0) {
				additionalOffset =  open.height();
			}
			const offsetFromTop = 178;
			$('html,body').animate({
			  scrollTop: card.offset().top - additionalOffset - offsetFromTop
			}, 500);
		  });
	}
});


/**
 * Pupil tracking for cat.svg.
 *
 */
jQuery(function ($) {
	var catSvg = document.getElementById('cat');
	if (!catSvg) {
		return;
	}

	var EYE = {
		r: { org: [328.50, 316.50], ax: 10, ay: 8, deg: -22.6 },
		l: { org: [232.10, 323.90], ax: 10, ay: 8, deg: 13.2 }
	};

	var SAT = 240;   // pointer distance, in viewBox units, at which deflection maxes out
	var EASE = 0.18; // per-frame approach toward the target; 1 = no smoothing

	function catEyes(svg) {
		var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
		var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
		var ease = reduced ? 1 : EASE;

		var eyes = ['r', 'l'].map(function (k) {
			var el = svg.getElementById(k + '-pupil');
			if (!el) throw new Error('catEyes: missing #' + k + '-pupil');
			var cfg = EYE[k], rad = cfg.deg * Math.PI / 180;
			return {
				el: el,
				ox: cfg.org[0], oy: cfg.org[1],
				// constant nudge from where the pupil is drawn to where it pivots
				bx: cfg.org[0] - parseFloat(el.getAttribute('cx')),
				by: cfg.org[1] - parseFloat(el.getAttribute('cy')),
				ax: cfg.ax, ay: cfg.ay,
				cos: Math.cos(rad), sin: Math.sin(rad),
				x: 0, y: 0, tx: 0, ty: 0
			};
		});

		// Rotate a direction into the eye's own axes, scale it there, rotate back.
		function deflect(e, ux, uy, k) {
			var lx = ux * e.cos + uy * e.sin;
			var ly = -ux * e.sin + uy * e.cos;
			var px = lx * e.ax * k, py = ly * e.ay * k;
			e.tx = e.bx + px * e.cos - py * e.sin;
			e.ty = e.by + px * e.sin + py * e.cos;
		}

		// Cached screen -> viewBox matrix; dropped whenever the SVG could have moved.
		var pt = svg.createSVGPoint(), inv = null;
		function drop() { inv = null; }

		function aim(clientX, clientY) {
			if (!inv) {
				var m = svg.getScreenCTM();
				if (!m) return;
				inv = m.inverse();
			}
			pt.x = clientX; pt.y = clientY;
			var p = pt.matrixTransform(inv);
			for (var i = 0; i < eyes.length; i++) {
				var e = eyes[i], dx = p.x - e.ox, dy = p.y - e.oy;
				var d = Math.sqrt(dx * dx + dy * dy);
				if (d < 0.001) { rest1(e); continue; }
				deflect(e, dx / d, dy / d, Math.min(1, d / SAT));
			}
		}

		function rest1(e) { e.tx = e.bx; e.ty = e.by; }
		function rest() { for (var i = 0; i < eyes.length; i++) rest1(eyes[i]); }

		// No fine pointer (touch): a slow wander, interrupted by taps.
		var drifting = !fine, touchedAt = 0;
		function drift(t) {
			var s = t / 1000;
			var x = Math.sin(s * 0.45) * 0.8 + Math.sin(s * 0.17) * 0.2;
			var y = Math.sin(s * 0.31 + 1.3) * 0.6;
			for (var i = 0; i < eyes.length; i++) deflect(eyes[i], x, y, 1);
		}

		var raf = 0;
		function schedule() { if (!raf) raf = requestAnimationFrame(frame); }
		function frame(t) {
			raf = 0;
			if (!fine && !drifting && t - touchedAt > 2000) drifting = true;
			if (drifting) drift(t);

			var busy = false;
			for (var i = 0; i < eyes.length; i++) {
				var e = eyes[i];
				e.x += (e.tx - e.x) * ease;
				e.y += (e.ty - e.y) * ease;
				e.el.setAttribute('transform', 'translate(' + e.x.toFixed(2) + ' ' + e.y.toFixed(2) + ')');
				if (Math.abs(e.tx - e.x) > 0.01 || Math.abs(e.ty - e.y) > 0.01) busy = true;
			}
			if (busy || drifting) schedule();
		}

		function onMove(ev) {
			if (ev.pointerType !== 'mouse') { drifting = false; touchedAt = performance.now(); }
			aim(ev.clientX, ev.clientY);
			schedule();
		}
		function onLeave() { if (fine) { rest(); schedule(); } }

		addEventListener('pointermove', onMove, { passive: true });
		addEventListener('resize', drop);
		addEventListener('scroll', drop, true);
		document.addEventListener('pointerleave', onLeave);
		rest();      // start centred in the eyes, not at the authored glance
		schedule();

		return {
			destroy: function () {
				removeEventListener('pointermove', onMove);
				removeEventListener('resize', drop);
				removeEventListener('scroll', drop, true);
				document.removeEventListener('pointerleave', onLeave);
				if (raf) cancelAnimationFrame(raf);
			}
		};
	}

	catEyes(catSvg);
});


// Count-up animation for the ".counter" stats block, triggered on scroll into view
jQuery(function ($) {
	var counters = document.querySelectorAll('.counter h2');
	if (!counters.length) {
		return;
	}

	var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
	var DURATION = 1500;

	// Splits "1,500+" / "90%" / "2 weeks" into its numeric part and surrounding text
	function parseCounter(text) {
		var match = text.match(/[\d][\d,]*\.?\d*/);
		if (!match) {
			return null;
		}
		var numberText = match[0];
		var decimals = numberText.indexOf('.') !== -1 ? numberText.split('.')[1].length : 0;
		return {
			prefix: text.slice(0, match.index),
			suffix: text.slice(match.index + numberText.length),
			target: parseFloat(numberText.replace(/,/g, '')),
			decimals: decimals,
			grouped: numberText.indexOf(',') !== -1
		};
	}

	function formatCounter(value, counter) {
		var number = counter.decimals ? value.toFixed(counter.decimals) : String(Math.round(value));
		if (counter.grouped) {
			var parts = number.split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			number = parts.join('.');
		}
		return counter.prefix + number + counter.suffix;
	}

	function animateCounter(el) {
		var counter = parseCounter(el.textContent.trim());
		if (!counter || isNaN(counter.target)) {
			return;
		}
		if (reduced) {
			el.textContent = formatCounter(counter.target, counter);
			return;
		}

		var start = null;
		function step(timestamp) {
			if (!start) {
				start = timestamp;
			}
			var progress = Math.min((timestamp - start) / DURATION, 1);
			var eased = 1 - Math.pow(1 - progress, 3);
			el.textContent = formatCounter(counter.target * eased, counter);
			if (progress < 1) {
				requestAnimationFrame(step);
			}
		}
		requestAnimationFrame(step);
	}

	if (!('IntersectionObserver' in window)) {
		counters.forEach(animateCounter);
		return;
	}

	var observer = new IntersectionObserver(function (entries, obs) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				animateCounter(entry.target);
				obs.unobserve(entry.target);
			}
		});
	}, { threshold: 0.4 });

	counters.forEach(function (counter) {
		observer.observe(counter);
	});
});


// "Choose your products" platform tabs: click a .block-platfrom card to fade in its matching .section-platform panel
jQuery(function ($) {
	var $triggers = $('.block-platfrom');
	var $panels = $('.section-platform');
	var FADE_SPEED = 300;

	if (!$triggers.length || !$panels.length) {
		return;
	}

	$panels.not(':first').hide();
	$triggers.first().addClass('active');

	$triggers.on('click', function () {
		var $card = $(this);
		if ($card.hasClass('active')) {
			return;
		}

		var $target = $panels.eq($triggers.index($card));

		$triggers.removeClass('active');
		$card.addClass('active');

		$panels.filter(':visible').fadeOut(FADE_SPEED, function () {
			$target.fadeIn(FADE_SPEED);
		});
	});
});

